module.exports = __webpack_public_path__ + "src/img/whattodo4.jpg?597face4a822f844bae592f600a6bd50";


//////////////////
// WEBPACK FOOTER
// ./src/img/whattodo4.jpg
// module id = 215
// module chunks = 0